<template>
  <div class="departure">
    <div class="departure-content">
      <div class="d-flex">
        <div>
          <figure
            class="departure-poster"
            v-if="img"
          >
            <img
              :src="'/api/images/departures/' + img"
              class="departure-poster-img"
              @error="img = null"
            >
          </figure>
        </div>
        <div class="departure-desc">
          <h3 class="departure-desc-title">
            DETALLES DEL PAQUETE
          </h3>
          <div>
            <span v-if="departure.duration">{{ departure.duration }}</span> /
            <span v-if="departure.amenity">{{ departure.amenity }}</span>
          </div>
          <p v-if="departure.description">
            {{ departure.description }}
          </p>
          <p v-if="departure.boardings">
            LUGARES DE EMBARQUE: {{ departure.boardings.map(a => a.name).join(', ') }}
          </p>
          <div class="ml-n2">
            <template v-for="item in departure.attached_link">
              <a
                class="btn btn-link"
                :href="item.link"
                :key="item.link"
                target="_blank"
              >
                {{ item.title }}
              </a>
            </template>
          </div>
        </div>
      </div>
      <div
        class="departure-rates"
        v-if="prices.length"
      >
        <h3 class="border-bottom px-3">
          TARIFAS VIGENTES
        </h3>
        <div class="table-responsive">
          <table class="tbl">
            <tr>
              <th>DETALLE</th>
              <th v-if="!departure.preview">
                DISPONIBILIDAD
              </th>
              <th v-if="th.single">
                SINGLE
              </th>
              <th v-if="th.double">
                DOBLE
              </th>
              <th v-if="th.triple">
                TRIPLE
              </th>
              <th v-if="th.quadruple">
                CUADRUPLE
              </th>
              <th v-if="th.kids">
                MENORES
              </th>
              <th v-if="th.infoas">
                INFOA C/B
              </th>
            </tr>
            <tr
              v-for="(rate, i) in prices"
              :key="i"
            >
              <td class="txt-upper">
                <span>{{ rate.detail }}</span> /
                <strong>{{ rate.category }}</strong>
              </td>
              <td v-if="!departure.preview">
                <span
                  class="pill"
                  :class="rate.availability.class"
                >
                  {{ rate.availability.str }}
                </span>
              </td>
              <td
                v-if="th.single"
                class="text-nowrap"
              >
                <span>{{ rate.single }}</span>
              </td>
              <td
                v-if="th.double"
                class="text-nowrap"
              >
                <span>{{ rate.double }}</span>
              </td>
              <td
                v-if="th.triple"
                class="text-nowrap"
              >
                <span>{{ rate.triple }}</span>
              </td>
              <td
                v-if="th.quadruple"
                class="text-nowrap"
              >
                <span>{{ rate.quadruple }}</span>
              </td>
              <td
                v-if="th.kids"
                class="text-nowrap"
              >
                <span>{{ rate.kids }}</span>
              </td>
              <td
                v-if="th.infoas"
                class="text-nowrap"
              >
                <span>{{ rate.infoas }}</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div
        v-else
        class="clear"
      >
        <h3>No hay tarifas disponibles</h3>
      </div>
      <div class="departure-observations">
        <p
          v-for="(item, i) in notes"
          :key="i"
        >
          {{ item.prefix }}{{ item.note }}
        </p>
      </div>
    </div>
    <div class="departure-footer txt-right py-2 border-top mt-3">
      <btn
        color="white"
        size="xs"
        @click="$emit('close')"
      >
        VOLVER
      </btn>
    </div>
  </div>
</template>
<script>
/* eslint no-mixed-spaces-and-tabs: "off" */
import Btn from '@/components/Btn'

const tags = [
  { class: 'pill-lblue', str: 'Consultar' },
  { class: 'pill-black', str: 'Disponible' },
  { class: 'pill-red', str: 'Sin Disponibilidad' }
]

export default {
  components: {
    Btn
  },

  name: 'Detail',

  props: ['departure'],

  methods: {
    print () {
      window.print()
    }
  },

  data () {
    const rates = this.departure.rates || []

    const notes = rates
      .reduce(
        (notes, rate) =>
          rate.prices.reduce(
            (res, price) => res.concat([price.kids_note, price.infoas_note]),
            notes
          ),
        []
      )
      .filter(note => note)
      .map(note => note.trim())
      .filter((note, i, self) => self.indexOf(note) === i)
      .map((note, i) => ({ prefix: '*'.repeat(i + 1), note }))

    const th = {
      single: rates.some(rate => rate.prices.some(price => !!price.single)),
      double: rates.some(rate => rate.prices.some(price => !!price.double)),
      triple: rates.some(rate => rate.prices.some(price => !!price.triple)),
      quadruple: rates.some(rate => rate.prices.some(price => !!price.quadruple)),
      infoas: rates.some(rate => rate.prices.some(price => !!price.infoas)),
      kids: rates.some(rate => rate.prices.some(price => !!price.kids))
    }

    const prices = rates
      .map(rate =>
        rate.prices.map(price => ({
          id: rate.id,
          detail: rate.detail,
          availability: tags[rate.availability],
          category: price.categ_str,
          single: price.single
            ? this.departure.currency + ' ' + parseInt(price.single)
            : '-',
          double: price.double
            ? this.departure.currency + ' ' + parseInt(price.double)
            : '-',
          triple: price.triple
            ? this.departure.currency + ' ' + parseInt(price.triple)
            : '-',
          quadruple: price.quadruple
            ? this.departure.currency + ' ' + parseInt(price.quadruple)
            : '-',
          kids: price.kids
            ? notes.reduce(
              (res, el) =>
                price.kids_note && el.note == price.kids_note.trim()
                  ? this.departure.currency +
										  ' ' +
										  parseInt(price.kids) +
										  el.prefix
                  : res,
              this.departure.currency + ' ' + parseInt(price.kids)
						  )
            : '-',
          infoas: price.infoas
            ? notes.reduce(
              (res, el) =>
                price.infoas_note && el.note == price.infoas_note.trim()
                  ? this.departure.currency +
										  ' ' +
										  parseInt(price.infoas) +
										  el.prefix
                  : res,
              this.departure.currency + ' ' + parseInt(price.infoas)
						  )
            : '-'
        }))
      )
      .reduce((prices, rate) => prices.concat(rate), [])

    return {
      th,
      prices,
      notes,
      img: this.departure.img
    }
  }
}
</script>
